export const DsAvatarDefaultProps = {
    'ds-size': 'L'
};
